<template>
  <NavView></NavView>
    <SideBar></SideBar>
<div class="container-fluid mb-5" >
    <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
    <h6 class="manage-boder pt-2 font1 font-bold1 ps-1"> <router-link class="decoration" to="/user-management/permission/index"> Permmission groups </router-link></h6>
    
   
    <div class="d-grid gap-1 d-md-flex justify-content-md-end mb-1">
        <router-link class="line1 btn btn-primary btn-sm text-light" to="/user-management/user/index">Users</router-link> 
      <router-link class="line1 btn btn-primary btn-sm text-light" to="/user-management/role/index">Roles</router-link> 
      <router-link class="line1 btn btn-primary btn-sm text-light" to="/user-management/permission/index">Permission</router-link> 
      <router-link class="line1 btn btn-primary btn-sm text-light" to="/user-management/user-visit-log/index">Visit Log</router-link> 
      
    </div>

<div class="card">
  <div class="card-body">
    
 
  <div class="row">
    <div class="col align-self-start">
     
      <router-link class="line1 btn btn-primary btn-sm text-light mb-2" to="/user-management/auth-item-group/create">Create</router-link>
    </div>
    <div  class="col   d-md-flex justify-content-md-end mb-2">
     
        <input class="form-control  width7 font1 " type="search" placeholder="Search" aria-label="Search">
        
    </div>

    
  </div>



<Table id=""  class="table table-bordered table-hover">
  <thead>
    <tr>
      <th>#</th>
      <th>Name</th>
      <th>Code</th>
     
      
    
      <th>()</th>
     
     
      <th>Actions</th>
    </tr>
  </thead>
 
    
 
  <tbody>
   
    <!-- v-for="key in count" :key="key" -->
    <tr  >
      <th></th>
      
   
      <td></td>
      
    
   
      <td></td>
     
      
      
      

     
      <td ></td>
     <!--  <td ><span class="badge badge-danger border-radius0">Innactive</span></td> -->
     
      <td class="">
        <!-- <CButton  color="primary" size="sm" >view</CButton> -->
        <!-- <router-link :to="{ name: 'McustomerView', params:{ id : mcustomer.idCustomer} }" class=" btn btn-primary  btn-sm text-light " >View</router-link>  -->
        <div class="dropdown">
            <a class="btn btn-primary btn-sm dropdown-toggle " href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
              select
            </a>
          
            <ul class="dropdown-menu border1 " aria-labelledby="dropdownMenuLink">
             <!-- <li><router-link :to="{ name: 'McustomerView', params:{ id : mcustomer.idCustomer} }" class="dropdown-item text-light font-color1" >View</router-link>  </li> -->
             <!-- <li><a v-on:click="viewload(mcustomer.idCustomer)" class="dropdown-item text-light font-color1" >View</a>  </li> -->
              <!-- <li><a class="dropdown-item text-light font-color1" href="#">update</a></li> -->
             
              <li><a v-on:click="viewLoad()"  class="dropdown-item text-light font-color1">View</a></li>
           
              <li><a v-on:click="updateLoad()" class="dropdown-item text-light font-color1" >Update</a></li>
              <li><a class="dropdown-item text-light font-color1" >Delete</a></li>
             
           
            </ul>
          </div>
        
        
      </td>
    </tr>
    
    
  </tbody>
</Table>
<nav aria-label="Page navigation example">
  <ul  class="pagination justify-content-end">
    <li class="page-item"><a class="page-link" href="#">Previous</a></li>
    <li v-for="key in totalItem" :key="key" class="page-item " >
      <a class="page-link" v-on:click="page(key)" >{{key}}</a>
    </li>
 
   
    <li class="page-item">
      <a class="page-link" >Next</a>
    </li>
  </ul>
</nav>
</div>
</div>


</div>
<!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
<!-- <form @submit.prevent="del()" class="" >
 <input type="text" v-model="user.id"  class="form-control" >
 <button  type="" class="btn btn-success" >delete</button>
 </form> -->

</template>

<script>
 //import {   CButton, } from '@coreui/vue';
 //import httpClient from '@/axios';
 import axios from 'axios';
 import authService from '@/auth.service';
 import NavView from '../../NavView.vue'
  import SideBar from '../../SideBar.vue'



export default {
    components:{ 
      NavView,SideBar
    },

    mounted(){
  this.loadIgrn()
    },
   

    data(){
    return{
      
        igrns:'',
      access_token:authService.isLoggedIn(),
     
     
        

      
  
     
    };
    },


   methods:{ 



    viewLoad() {
   
   this.$router.push('/user-management/auth-item-group/view'); 
        //this.$refs.table.innerHTML = response.data.success;
        
  } ,

  updateLoad(){
    this.$router.push('/user-management/auth-item-group/update');
  },


 

    async loadIgrn() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/web/api/ig',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.igrns = data.item_list;
       this.totalItem = Math.ceil((data.totalItems)/10);
    } catch (error) {
      console.log(error.response);
    }
  },
   

  async page(pageid){
  this.$router.push('/igrn/index?page='+pageid); 
  try {
        const { data} = await  axios.get('/web/api/igrn/index?page='+pageid,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.igrns = data.item_list;
       this.totalItem = Math.ceil((data.totalItems)/10);
       



      } catch (error) {
        console.log(error.response);
      }
    
  }, 






}




};

</script>

<style scoped>
.button1{
  width: 10px !important;
}
.border1{
  border: none;
  background-color: #0d6efd;
}
.font-color1:hover{
  color: black !important;
  cursor: pointer;
}
.manage-boder{
  border-bottom: 1px solid #E9E9E3;
  border-top: 1px solid #E9E9E3;
}


.font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .width7{
    width: 250px;
  }

</style>